// Helpers for rendering backend-driven form schemas.

// Minimal structural view of a schema field, so both destination and source field types fit.
type SchemaField = {
  name: string;
  form_element: string;
  input_type?: string;
};

export const isSecretField = (field: SchemaField): boolean =>
  (field.form_element === "input" && field.input_type === "password") || field.name === "service_account_key";

// to mark secret values that are intentionally hidden
export const hiddenSecretValue = <span className="text-gray-300 italic">Intentionally hidden</span>;
